import { getRoutesFromStepper } from '@folio/components/layout/StepperLayout/getRoutesFromStepper';
import { DocumentsStep } from './DocumentsStep';
import { EffectiveDateStep } from './EffectiveDateStep';
import { ReasonStep } from './ReasonStep';
import { RecapStep } from './RecapStep';

/**
 * One route per step, so Back, refresh and resuming a draft all land where the user left off.
 * `afterEndPath` is where the recap's confirmation returns to.
 */
export const getStopFunnelRoutes = ({
  basePath,
  afterEndPath,
}: {
  basePath: string;
  afterEndPath: string;
}) => {
  const firstStepPath = `${basePath}/reason`;
  const documentsPath = `${basePath}/documents`;
  const recapPath = `${basePath}/recap`;

  return getRoutesFromStepper({
    // key per step, like mapConfigToStep: React reuses the instance across same-type steps
    // otherwise, and a step added later would silently keep the previous one's state.
    steps: [
      {
        path: 'reason',
        element: <ReasonStep key="reason" documentsPath={documentsPath} recapPath={recapPath} />,
      },
      {
        path: 'date',
        element: (
          <EffectiveDateStep key="date" firstStepPath={firstStepPath} recapPath={recapPath} />
        ),
      },
      // Reasons asking for no proof skip straight past this one; it stays routed so Back from the
      // recap has somewhere to land.
      {
        path: 'documents',
        element: <DocumentsStep key="documents" firstStepPath={firstStepPath} />,
      },
      { path: 'recap', element: <RecapStep key="recap" firstStepPath={firstStepPath} /> },
    ],
    basePath,
    afterEndPath,
    stepsI18nPrefix: 'stopFunnel.steps',
  });
};
